export default "__VITE_ASSET__CGD4DfDV__"